
window.onload = () => {
    var ageModal  = document.getElementById("prompt-background");
    if  (sessionStorage.getItem("age_verification") == 1) {
        ageModal.style.display = "none"
    }
    else {
        ageModal.style.display = "flex"
    }
}



// function setCookie(cname, cvalue, exyears) {
//     const d = new Date();
//     d.setTime(d.getTime() + (exyears * 365 * 24 * 60 * 60 * 1000));
//     let expires = "expires="+d.toUTCString();
//     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function getCookie(cname) {
//     let name = cname + "=";
//     let ca = document.cookie.split(';');
//     for(let i = 0; i < ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) == ' ') {
//         c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//         console.log(c.substring(name.length, c.length));
//         return c.substring(name.length, c.length);
//         }
//     }
//     console.log("nothing");
//     return "";
    
// }

// function checkVerification() {
//     let user = getCookie("verification");
//     console.log(user);
//     if (user != '') {
//         return true
//     }
//     else {
//         return false
//     }
// }

function ageVerify() {
    sessionStorage.setItem("age_verification", "1");
    document.getElementById("prompt-background").style.display = "none";
}